export class HomeModel {

  NewArticles: number = 0;
  WIP: number = 0;
  ReadytoPublish: number = 0;
  Published: number = 0;
  Withdrawn: number = 0;

  WidgetItem: JSON;
  ArticleSummary: JSON;

  showAuthorDataModal: boolean;

  showModal: boolean;
  status: boolean = false;
  title: string;

  ingestTitle: string;
  ingestStatus: string;
  ingestStartDate: string;
  ingestCompleteDate: string;
  ingestDescription: string;

  uccStatus: string;
  uccStartDate: string;
  uccCompleteDate: string;
  uccDescription: string;
  ProjectManagerList: any;
}
